/*
var $thumbnailProductGallery = $('.product-slideshow').find('.product-thumbnails.flicky');
var flkty = new Flickity( '.product-thumbnails.flicky', {
    cellAlign: 'center',
    contain: true,
    groupCells: '80%',
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: true,
    verticalCells: true,
    arrowShape: 'm88.06492,42.97897l-63.40262,0l27.33874,-25.51181c1.74503,-1.62841 1.74503,-4.34244 0,-5.97085c-1.74503,-1.62841 -4.07173,-1.62841 -5.81675,0l-34.90052,32.56826c-1.74503,1.62841 -1.74503,4.34244 0,5.97085l34.90052,32.56826c1.74503,1.62841 4.6534,1.62841 6.39843,0c1.74503,-1.62841 1.74503,-3.79963 0,-5.42804l-27.33874,-26.05461l63.40262,0c2.3267,0 4.6534,-1.62841 4.6534,-4.34244c-1.16335,-2.17122 -2.90838,-4.34244 -5.23508,-3.79963l0,0z'
 });

 flkty.on( 'select', function() {
    var target = flkty.selectedCell.target;
    var $btn_previous = $('.product-thumbnails.flicky').find('.previous');
    var $btn_next = $('.product-thumbnails.flicky').find('.next');
    console.log(target);
    if ( target == flkty.cells[0].target ) {
        $btn_previous.addClass("first-selected");
        $btn_next.removeClass("last-selected");
      console.log('is at contained start');
    } else if ( target == flkty.getLastCell().target ) {
        $btn_previous.removeClass("first-selected");
        $btn_next.addClass("last-selected");
      console.log('is at contained end');
    } else {
        $btn_previous.removeClass("first-selected");
        $btn_next.removeClass("last-selected");
    }
  });
*/

var $thumbnailProductGallery = $('.product-slideshow').find('.product-thumbnails.slick');
var $productmainthumbnail= $('.product-slideshow').find('.product-big-image');

$thumbnailProductGallery.slick({
  dots: false,
  vertical: false,
  prevArrow: $('.flickity-prev-next-button.previous'),
  nextArrow: $('.flickity-prev-next-button.next'),
  infinite: false,
  slidesToShow: 3,
  focusOnSelect: true,
  asNavFor: $productmainthumbnail
});

$productmainthumbnail.slick({
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: $thumbnailProductGallery
});

$(document).on('mousemove', '[data-slide-hover]', function(evt){
  let target = $(this);
  let containerWidth = target.width();
  let posX = evt.pageX - target.offset().left;
  
  if(posX < containerWidth / 2){
    target.attr('data-direc', 'left');
  }
  else {
    target.attr('data-direc', 'right');
  }
})

var count = 0;
$('[data-slide-hover] .slick-slide img').on('click', function(evt){
  evt.preventDefault();
  count ++;
  var $obj = $(this).closest('[data-slide-hover]');
  var handle = $obj.attr('data-direc');
  if(count == 1){
    if(handle == 'left') {
      if($(window).width() > 940) {
        $obj.find('button.slick-arrow.slick-prev').click();
      }
    }
    else {
      if($(window).width() > 940) {
        $obj.find('button.slick-arrow.slick-next').click();
      }
    }
    setTimeout(function(){
      count = 0;
    }, 500);
  }
})
